import api from './api';
import {
  Canal,
  Topico,
  Comentario,
  CriarCanalDto,
  EditarCanalDto,
  CriarTopicoDto,
  EditarTopicoDto,
  CriarComentarioDto,
  EditarComentarioDto
} from '../types/comunicacao';

class ComunicacaoService {
  // ==================== CANAIS ====================
  
  async listarCanais(): Promise<Canal[]> {
    const response = await api.get('/canais');
    return response.data.canais;
  }

  async obterCanal(id: string): Promise<Canal> {
    const response = await api.get(`/canais/${id}`);
    return response.data.canal;
  }

  async criarCanal(dados: CriarCanalDto): Promise<Canal> {
    const response = await api.post('/canais', dados);
    return response.data.canal;
  }

  async editarCanal(id: string, dados: EditarCanalDto): Promise<Canal> {
    const response = await api.put(`/canais/${id}`, dados);
    return response.data.canal;
  }

  async removerCanal(id: string): Promise<void> {
    await api.delete(`/canais/${id}`);
  }

  // ==================== TÓPICOS ====================

  async listarTopicos(canalId: string): Promise<Topico[]> {
    const response = await api.get(`/topicos/canal/${canalId}`);
    return response.data.topicos;
  }

  async obterTopico(id: string): Promise<Topico> {
    const response = await api.get(`/topicos/${id}`);
    return response.data.topico;
  }

  async criarTopico(dados: CriarTopicoDto): Promise<Topico> {
    const response = await api.post('/topicos', dados);
    return response.data.topico;
  }

  async editarTopico(id: string, dados: EditarTopicoDto): Promise<Topico> {
    const response = await api.put(`/topicos/${id}`, dados);
    return response.data.topico;
  }

  async removerTopico(id: string): Promise<void> {
    await api.delete(`/topicos/${id}`);
  }

  // ==================== COMENTÁRIOS ====================

  async listarComentarios(topicoId: string): Promise<Comentario[]> {
    const response = await api.get(`/comentarios/topico/${topicoId}`);
    return response.data.comentarios;
  }

  async criarComentario(dados: CriarComentarioDto): Promise<Comentario> {
    const response = await api.post('/comentarios', dados);
    return response.data.comentario;
  }

  async editarComentario(id: string, dados: EditarComentarioDto): Promise<Comentario> {
    const response = await api.put(`/comentarios/${id}`, dados);
    return response.data.comentario;
  }

  async removerComentario(id: string): Promise<void> {
    await api.delete(`/comentarios/${id}`);
  }

  // ==================== ANEXOS ====================

  async listarAnexosTopico(topicoId: string): Promise<any[]> {
    const response = await api.get(`/comunicacao-anexos/topico/${topicoId}`);
    return response.data.anexos;
  }

  async uploadAnexoTopico(topicoId: string, file: File): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(`/comunicacao-anexos/topico/${topicoId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data.anexo;
  }

  async removerAnexoTopico(anexoId: string): Promise<void> {
    await api.delete(`/comunicacao-anexos/topico/${anexoId}`);
  }

  async downloadAnexo(anexoId: string): Promise<string> {
    const response = await api.get(`/comunicacao-anexos/download/${anexoId}`);
    return response.data.url;
  }
}

export default new ComunicacaoService();
